<template>
  <div class="wlx-site-manager-wrapper">
    <header class="site-manager-head-con">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="title" placeholder="培训标题" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getPeiXunList()">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>

    <el-table :data="EnrollList" @selection-change="handleSelectionChange" style="width: 100%">
      <el-table-column prop="Id" type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="title" label="培训标题" show-overflow-tooltip></el-table-column>
      <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="schoolTitle" label="学校名称" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column> -->
      <el-table-column prop="email" label="邮编" show-overflow-tooltip></el-table-column>
      <el-table-column prop="invoice" label="发票抬头" show-overflow-tooltip></el-table-column>
      <el-table-column prop="taxNumber" label="纳税人识别号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="planTime" label="培训时间" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.planTime">{{scope.row.planTime}}</span>
          <span v-else>---</span>
        </template>
      </el-table-column>
      <el-table-column prop="dateCreated" label="报名时间" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="220px">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="goLook(scope.row.id)">编辑</el-button>
          <!-- <el-button type="primary" size="mini" @click="getSignDetail(scope.row.id)">详情</el-button> -->
          <!-- <a
            type="primary"
            size="mini"
            :href="exprotHref + scope.row.id"
            class="export-table-btn"
          >导出报名表格</a> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="u-page-con">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100,200,500,1000]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        v-show="totalCount>0"
        style="text-align: center;"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      EnrollList: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      exprotHref: "/api/XOrg/MeetingEnroll/eportMeetingEnroll?MeetingEnrollId="
    };
  },
  components: {},
  computed: {
    userInfo() {
      return this.$store.state.auth;
    }
  },
  created() {
    this.getPeiXunList();
  },
  methods: {
    getSignDetail(id){
       this.$router.push({
        name: "trainSignDetail",
        params: {
          signUpId: id
        }
      });
    },
    goLook(id) {
      this.$router.push({
        name: "trainSignEdit",
        params: {
          signUpId: id
        }
      });
    },
    handleSelectionChange() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPeiXunList();
    },
    onPageChangeHandler(val) {
      this.page = val;
      this.getPeiXunList();
    },
    getPeiXunList() {
      var that = this;
      this.$http
        .post("/api/XOrg/PeiXunTea/getPeiXunList", {
          title: that.title,
          PageSize: that.pageSize,
          page: that.page
        })
        .then(rst => {
          if (rst.code > 0) {
            that.EnrollList = rst.list;
            that.page = rst.pagination.pageIndex;
            that.pageSize = rst.pagination.pageSize;
            that.totalCount = rst.pagination.totalCount;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
  padding: 20px 30px 0 30px;
  // padding: 20px;
  // background: #fff;
  .el-input--suffix .el-input__inner {
    padding-right: 30px;
    height: 34px;
  }
  .export-table-btn {
  
    margin-left: 10px;
    color: #fff;
    padding: 7px 15px;
    background-color: #409eff;
    border-radius: 3px;
    font-size: 12px;
  }
}
</style>
